import { useMemo } from 'react'

import { Icon } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import Experiment from '@mc/experiments-react'

import styles from 'components/Subscription/Subscription.module.scss'

export const PEN_5590_V1_LEARNING_TOOLKIT_EXP_FLAG = 'pen-5590_v1'

export const LearningToolkitRemovalExperiment = ({
  control,
}: {
  control: () => React.ReactNode
}) => {
  const { t } = useTranslation('@mc/next')

  const list = useMemo(
    () => [
      {
        icon: 'lessons',
        text: t('subscription.info.allClassesWithSeries', {
          instructors: getNumberOfInstructors(),
        }),
      },
      {
        icon: 'unmuted',
        text: t('subscription.info.audio'),
      },
      {
        icon: 'download',
        text: t('subscription.info.offline'),
      },
      {
        icon: 'lessons',
        text: t('subscription.info.devices'),
      },
      {
        icon: 'star',
        text: t('subscription.info.newClasses'),
      },
      {
        icon: 'check',
        text: t('subscription.info.moneyBack'),
      },
    ],
    [t],
  )
  return (
    <Experiment
      name={PEN_5590_V1_LEARNING_TOOLKIT_EXP_FLAG}
      control={control}
      variant_1={() =>
        list.map(({ icon, text }) => (
          <li key={text} className={`d-flex mc-my-3 ${styles.item}`}>
            <div>
              <Icon
                kind={icon}
                className='mc-icon--3 mc-opacity--hinted mc-mr-3'
              />
            </div>
            {text}
          </li>
        ))
      }
    />
  )
}
